<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2">
        Identify which of the structures shown here correspond to each of the chemical names below:
      </p>

      <v-img
        :src="$publicAsset('/img/assignments/uci-51lb-a1-q6.png')"
        style="max-width: 413px"
        class="ml-6 mb-4"
      />

      <v-simple-table>
        <thead>
          <tr v-for="question in questions" :key="question.vModel" class="mb-0 mt-0">
            <td>
              <stemble-latex :content="question.text" />
            </td>
            <td>
              <v-select
                v-model="inputs[question.vModel]"
                class="my-1"
                :items="options"
                item-text="text"
                item-value="value"
                style="display: inline-block; width: 143px"
              >
                <template #item="{item}">
                  <stemble-latex class="no-text-transform" :content="item.text" />
                </template>
                <template #selection="{item}">
                  <stemble-latex class="no-text-transform" :content="item.text" />
                </template>
              </v-select>
            </td>
          </tr>
        </thead>
      </v-simple-table>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'ChemUCI51LBA1Q6',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
        input2: null,
        input3: null,
        input4: null,
        input5: null,
        input6: null,
      },
      questions: [
        {
          text: 'a) Diethyl ether: ',
          vModel: 'input4',
        },
        {
          text: 'b) Ethyl acetate: ',
          vModel: 'input2',
        },
        {
          text: 'c) Acetone: ',
          vModel: 'input3',
        },
        {
          text: 'd) Ethanol: ',
          vModel: 'input6',
        },
        {
          text: 'e) Acetic anhydride: ',
          vModel: 'input5',
        },
        {
          text: 'f) Acetic acid: ',
          vModel: 'input1',
        },
      ],
      options: [
        {text: 'Molecule A', value: 'a'},
        {text: 'Molecule B', value: 'b'},
        {text: 'Molecule C', value: 'c'},
        {text: 'Molecule D', value: 'd'},
        {text: 'Molecule E', value: 'e'},
        {text: 'Molecule F', value: 'f'},
      ],
    };
  },
};
</script>
